import { action, makeObservable, observable } from "mobx";
export type ModalStoreProps = {
    display?: boolean,
    showClose?: boolean,
    cssClassName?: string
    onClose?: any;
}

class ModalStore {
    onClose?: any;
    display = true;
    showClose?: boolean;
    cssClassName?: string

    private initialize(props?: ModalStoreProps) {
        if (!props) {
            return;
        }

        this.cssClassName = props.cssClassName ?? this.cssClassName;
        this.display = props.display ?? this.display;
        this.showClose = props.showClose ?? this.showClose;
        this.onClose = props.onClose ?? this.onClose;
    }

    constructor(initialValues?: ModalStoreProps) {
        this.initialize(initialValues);

        makeObservable(this, {
            //onClose: observable,
            display: observable,
            showClose: observable,
            cssClassName: observable,
            updateDisplay: action,
            updateOnClose: action
        })
    }

    updateDisplay(value: boolean) {
        this.display = value;
    }

    updateOnClose(value: any) {
        this.onClose = value;
    }
}

export default ModalStore;
